import store from "@/store";
import WarningIcon from "@/assets/images/icons/modal-warning.svg";
import CheckIcon from "@/assets/images/icons/check.svg";
import ErrorIcon from "@/assets/images/icons/cross.svg";
import FormErrorIcon from "@/assets/images/icons/form-warning.svg";
import i18n from "@/libs/i18n";

export default function useValidationModal() {
  const openValidationModal = () => {
    store.commit("baseComponent/OPEN_VALIDATION_MODAL");
  };

  const closeValidationModal = (callback) => {
    if (callback) callback();

    return store.commit("baseComponent/CLOSE_VALIDATION_MODAL");
  };

  const openWarningModal = (
    title = "",
    description = "",
    onConfirm = null,
    onCancel = null,
    onClose = null,
    confirmLabel = "",
    confirmBtn_Disabled = false,
    cancelBtn_Disabled = false,
    titleClass = null
  ) => {
    const payload = {
      title,
      description,
      type: "warning",
      onConfirm,
      onCancel,
      onClose,
      confirmLabel,
      confirmBtn_Disabled,
      cancelBtn_Disabled,
      titleClass,
    };

    store.commit("baseComponent/OPEN_VALIDATION_MODAL", payload);
  };

  const openSuccessModal = (
    title = "",
    description = "",
    confirmLabel = "",
    onConfirm = null,
    onClose = null
  ) => {
    const payload = {
      title,
      description,
      confirmLabel,
      type: "success",
      onConfirm,
      onCancel: null,
      onClose,
    };

    store.commit("baseComponent/OPEN_VALIDATION_MODAL", payload);
  };

  const openErrorModal = (
    title = "",
    description = "",
    confirmLabel = "",
    onConfirm = null,
    onClose = null
  ) => {
    const payload = {
      title,
      description,
      confirmLabel,
      type: "error",
      onConfirm,
      onCancel: null,
      onClose,
    };

    store.commit("baseComponent/OPEN_VALIDATION_MODAL", payload);
  };

  const openFormErrorModal = (
    title = "",
    description = "",
    confirmLabel = "กลับไปแก้ไข",
    onConfirm = null,
    onClose = null
  ) => {
    const payload = {
      title,
      description,
      confirmLabel,
      type: "form-error",
      onConfirm,
      onCancel: null,
      onClose,
    };

    store.commit("baseComponent/OPEN_VALIDATION_MODAL", payload);
  };

  const openDefaultErrorModal = (error, language = "th") => {
    let title = "เกิดข้อผิดพลาด";
    let detail = "เกิดข้อผิดพลาด กรุณาติดต่อ ChocoCRM";

    if (error?.data) {
      const errorResponse = error.data.error;
      let localeTitle = null;
      let localeDetail = null;

      if (language == "th") {
        localeTitle = errorResponse?.locale["th-th"]?.title;
      } else {
        localeTitle = errorResponse?.locale["en-us"]?.title;
      }

      if (language == "th") {
        localeDetail = errorResponse?.locale["th-th"]?.message;
      } else {
        localeDetail = errorResponse?.locale["en-us"]?.message;
      }

      title = localeTitle || "เกิดข้อผิดพลาด";
      detail = localeDetail || "เกิดข้อผิดพลาด กรุณาติดต่อ ChocoCRM";

      if (errorResponse?.code == 1000404 || errorResponse?.code == 1000400) {
        title = "เกิดข้อผิดพลาด";
        detail = "เกิดข้อผิดพลาด กรุณาติดต่อ ChocoCRM";
      }
      // if (errorResponse.code == 1000400 && errorResponse.message.length > 0) {
      //   detail = errorResponse.message;
      // }
    }

    openErrorModal(title, detail);
  };

  const resolveIcon = (type) => {
    const bodyStyles = document.body.style;
    // bodyStyles.setProperty('--modal-background', 'green,green');

    switch (type) {
      case "warning":
        bodyStyles.setProperty("--modalIcon", `url(${WarningIcon})`);
        bodyStyles.setProperty("--modal-background", "#B7B7B7");
        break;

      case "success":
        bodyStyles.setProperty("--modalIcon", `url(${CheckIcon})`);
        bodyStyles.setProperty("--modal-background", "#4CAF50");
        break;

      case "error":
        bodyStyles.setProperty("--modalIcon", `url(${ErrorIcon})`);
        bodyStyles.setProperty("--modal-background", "#C11732");
        break;

      case "form-error":
        bodyStyles.setProperty("--modalIcon", `url(${FormErrorIcon})`);
        bodyStyles.setProperty("--modal-background", "#FF4B4B");
        break;

      default:
        bodyStyles.setProperty(
          "--modalIcon",
          bodyStyles.setProperty("--modalIcon", `url(${WarningIcon})`)
        );
        break;
    }
  };

  return {
    openValidationModal,
    closeValidationModal,
    openWarningModal,
    openSuccessModal,
    openErrorModal,
    resolveIcon,
    openDefaultErrorModal,
    openFormErrorModal,
  };
}
